import * as React from 'react'
import Tag from './tag'

const Tags = ({
  tags,
  justify = 'justify-start',
  style = 'default',
  size = 'default',
  className = '',
}) => {
  if (tags) {
    let newTags = tags.map((tag) => {
      if (typeof tag === 'object') {
        if (!tag.style & tag.isCurrent) {
          tag.style = 'defaultSelected'
        }

        return tag
      }

      return {
        label: tag,
      }
    })

    return (
      <div className={`flex flex-wrap items-center text-sm -mb-3 ${justify} ${className}`}>
        {newTags.map((tag) => (
          <Tag key={tag.label} to={tag.to} href={tag.href} size={size} style={tag.style ?? style}>
            {tag.label}
          </Tag>
        ))}
      </div>
    )
  }

  return null
}

export default Tags
